import { render, staticRenderFns } from "./JobAndStudy.vue?vue&type=template&id=ac509c46&scoped=true&"
import script from "./JobAndStudy.vue?vue&type=script&lang=js&"
export * from "./JobAndStudy.vue?vue&type=script&lang=js&"
import style0 from "./JobAndStudy.vue?vue&type=style&index=0&id=ac509c46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac509c46",
  null
  
)

export default component.exports